module.exports = __webpack_public_path__ + "media/portfolio.5ce087ab.mp4";